import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import MainHeader from '../commons/Header/MainHeader';
import Nav from '../commons/Nav/Nav';
import Notification from '../commons/Notification';
// import BranchSelectorModal from '../components/home/BranchSelectorModal';

import {
    resetAppointmentsFlag
} from '../actions/appointments';

import {
    gotoLogin
} from '../actions/redirect';

import {
    getSessionApi
} from '../actions/session';

let $ = window.jQuery;
class App extends Component {
    static propTypes = {
        session: PropTypes.object.isRequired,
        gotoLogin: PropTypes.func.isRequired,
        resetAppointmentsFlag: PropTypes.func.isRequired,
        getSessionApi: PropTypes.func.isRequired
    };

    state = {
        notificationType: 'success',
        notificationShow: false,
        notificationMessage: ''
    };

    showNotification = (type, message) => {
        this.setState({
            notificationType: type,
            notificationShow: true,
            notificationMessage: message
        }, () => {
            setTimeout(() => {
                this.hideNotification();
                this.props.resetAppointmentsFlag();
            }, 2000);
        });
    };

    hideNotification = () => {
        this.setState({
            notificationShow: false,
        });
    };

    setupAjaxBeforeRequest = () => {
        // Ajax Config
        if (localStorage.getItem('token') !== null) {
            let access = localStorage.getItem('token');

            $(document).ajaxSend(function(event, jqXHR, ajaxOptions) {
                jqXHR.setRequestHeader('Authorization', 'Bearer ' + access);
            });
        }
    };

    componentWillMount() {
        document.body.style.backgroundColor = "#4d5b69";

        this.props.getSessionApi();
    }

    componentDidMount() {
        this.setupAjaxBeforeRequest();

        this.context.router.listen((e) => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    renderUnauthorized() {
        return (
            <div>Unauthorized</div>
        )
    }

    render() {
        const { session } = this.props;

        if (! session) {
            return this.renderUnauthorized();
        }

        if (! session.get('user')) {
            return this.renderUnauthorized();
        }

        let user = session.get('user');

        return (
            <div>
                <Notification type={this.state.notificationType}
                              show={this.state.notificationShow} message={this.state.notificationMessage} />

                <MainHeader user={user} history={this.props.history} />
                <div className="clearfix"> </div>

                <div className="page-container">
                    <Nav user={user} />

                    <div className="page-content-wrapper">
                        {React.cloneElement(this.props.children, {
                            showNotification: this.showNotification,
                            hideNotification: this.hideNotification,
                            user: user
                        })}
                    </div>
                </div>

                {/*<BranchSelectorModal user={user} showNotification={this.showNotification} />*/}
            </div>
        )
    }
}

App.contextTypes = {
    router: React.PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    session: state.session
});

export default connect(mapStateToProps, {
    resetAppointmentsFlag,
    gotoLogin,
    getSessionApi
})(App);


/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/